import HistoricalArbitrageTransactionInquiry from './historical-arbitrage-transaction-inquiry.vue'
export default HistoricalArbitrageTransactionInquiry
